import { render } from "./SummaryTab.vue?vue&type=template&id=55a66222&scoped=true"
import script from "./SummaryTab.vue?vue&type=script&lang=js"
export * from "./SummaryTab.vue?vue&type=script&lang=js"

import "./SummaryTab.vue?vue&type=style&index=0&id=55a66222&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a66222"]])

export default __exports__